module.exports = __webpack_public_path__ + "assets/284f266eda1135f36bbf4b0e96e1faed.png";